import axios from 'axios';
import { req } from './axiosFun';

// 登录接口 
export const login = (params) => { return req("post", "/login", params) };
// 修改管理员密码 
export const setPadws = (params) => { return req("post", "/index/setPass", params) };
// 获取用户菜单
export const menu = (params) => { return axios.get("/menu?&token=" + localStorage.getItem('logintoken')).then(res => res.data) };
// 退出接口
export const loginout = () => { return axios.delete("/login?&token=" + localStorage.getItem('logintoken')).then(res => res.data) };
// 用户管理
export const getuserList = (params) => { return req("post", "/user/index", params) };
// 商品管理
export const getshoplist = (params) => { return req("post", "/product/index", params) };
// 删除商品管理
export const deleteshoplist = (params) => { return req("post", "/product/delete", params) };
// 添加
export const getshoplistadd = (params) => { return req("post", "/product/add", params) };
// 修改
export const getshoplistedit = (params) => { return req("post", "/product/edit", params) };

// 教练管理
export const getTrainer = (params) => { return req("post", "/Trainer/index", params) };
// 添加
export const getTraineradd = (params) => { return req("post", "/Trainer/add", params) };
// 删除
export const getTrainerdelete = (params) => { return req("post", "/Trainer/delete", params) };
// 修改
export const getTraineredit = (params) => { return req("post", "/Trainer/edit", params) };
// 修改
export const setCard = (params) => { return req("post", "/Trainer/setCard", params) };
// 查询学员
export const getUser = (params) => { return req("post", "/Trainer/getUser", params) };
// 查询卡密
export const getCard = (params) => { return req("post", "/Trainer/getCard", params) };
// 重置密码
export const editPass = (params) => { return req("post", "/Trainer/editPass", params) };
// 修改卡密到期时间
export const editCard = (params) => { return req("post", "/Trainer/editCard", params) };
// 订单管理
export const getOrder = (params) => { return req("post", "/order/index", params) };


// 习题列表
export const getProblem = (params) => { return req("post", "/problem/index", params) };
// 修改习题
export const getedit = (params) => { return req("post", "/problem/edit", params) };
// 获取分类
export const getclassify = (params) => { return req("post", "/problem/classify", params) };
// 添加习题
export const getadd = (params) => { return req("post", "/problem/add", params) };
//上传图片
export const getupload = (params) => { return req("post", "/problem/getImg", params) };
//音频回显
export const geteditVoice= (params) => { return req("post", "/problem/editVoice", params) };
//生成音频
export const getsetVoice= (params) => { return req("post", "/problem/setVoice", params) };

// 习题分类列表
export const getclassifyindex = (params) => { return req("post", "/classify/index", params) };
// 习题分类添加
export const getclassifyadd = (params) => { return req("post", "/classify/add", params) };
// 批量添加
export const getclassifyallEdit = (params) => { return req("post", "/classify/allEdit", params) };
// 删除习题分类
export const getclassifydel = (params) => { return req("post", "/classify/del", params) };
// 删除习题分类
export const delRelational = (params) => { return req("post", "/classify/delRelational", params) };
// 修改习题分类
export const getclassifyedit = (params) => { return req("post", "/classify/edit", params) };
// 查看分类习题
export const getclassifyInfo = (params) => { return req("post", "/classify/classifyInfo", params) };

//视频管理 //视频列表
export const getexplain = (params) => { return req("post", "/art/explain", params) };
//视频管理 //视频添加
export const getaddMv = (params) => { return req("post", "/art/addMv", params) };
//视频管理 //视频列表删除
export const getdel = (params) => { return req("post", "/art/del", params) };
//视频管理 //视频列表修改
export const getartedit = (params) => { return req("post", "/art/edit", params) };
//考试秘籍 //秘籍列表
export const getcheats = (params) => { return req("post", "/art/cheats", params) };
//考试秘籍 //添加列表
export const getaddText = (params) => { return req("post", "/art/addText", params) };

//考试秘籍 //科二考试规则
export const getaddrules = (params) => { return req("post", "/art/rules", params) };
//考试秘籍 //科二考试流程
export const getaddprocess = (params) => { return req("post", "/art/process", params) };
//帮助中心
export const gethelp = (params) => { return req("post", "/help/index", params) };
//帮助中心添加
export const gethelpadd = (params) => { return req("post", "/help/add", params) };
//帮助中心修改
export const gethelpedit = (params) => { return req("post", "/help/edit", params) };
//帮助中心删除
export const gethelpdel = (params) => { return req("post", "/help/del", params) };
//代理
export const getPid = (params) => { return req("post", "/Trainer/getPid", params) };

//讲师列表
export const getLecturer = (params) => { return req("post", "/lecturer/index", params) };
//添加列表
export const getAddLecturer = (params) => { return req("post", "/lecturer/add", params) };
//代理分配列表
export const getTrainerUserId = (params) => { return req("post", "/lecturer/getTrainerUserId", params) };
//代理分配列表
export const getUpimg = (params) => { return req("post", "/lecturer/putFile", params) };
//修改代理列表
export const getLectureredit = (params) => { return req("post", "/lecturer/edit", params) };
//删除代理列表
export const getdelete = (params) => { return req("post", "/lecturer/delete", params) };
//修改代理密码
export const getUpResources= (params) => { return req("post", "/lecturer/upResources", params) };
//上传资质
export const getsetPass= (params) => { return req("post", "/lecturer/setPass", params) };
//提交审核
export const getBypartner= (params) => { return req("post", "/lecturer/bypartner", params) };
//查看审核状态
export const getStatus= (params) => { return req("post", "/lecturer/get_audit_detail", params) };
//授权小程序
export const getRole= (params) => { return req("post", "/lecturer/auth_role", params) };
//查看小程序状态
export const getRoleStatus= (params) => { return req("post", "/lecturer/get_appid_auth", params) };




//课程列表
export const getCourse= (params) => { return req("post", "/course/index", params) };
//添加课程
export const getAddCourse= (params) => { return req("post", "/course/add", params) };
//获取产品
export const getAgentProduct= (params) => { return req("post", "/course/getAgentProduct", params) };
//获取讲师
export const getAgentLecturer= (params) => { return req("post", "/course/getAgentLecturer", params) };
//修改课程
export const getCourseSet= (params) => { return req("post", "/course/edit", params) };
//删除课程
export const getCourseDel= (params) => { return req("post", "/course/delList", params) };
//课程列表2
export const getCourseList= (params) => { return req("post", "/course/List", params) };
//添加课程
export const getCourseAddList= (params) => { return req("post", "/course/addlist", params) };
//修改详细课程
export const getCourSet= (params) => { return req("post", "/course/editList", params) };
//上传材料
export const getCourseUpload= (params) => { return req("post", "/course/upload_resource", params) };
//查询材料上传状态
export const getCourseStatus= (params) => { return req("post", "/course/query_resource_status", params) };
//上传课程
export const getCouradd= (params) => { return req("post", "/course/dyAdd", params) };
//查询课程资源上传状态
export const getCouraddStatus= (params) => { return req("post", "/course/query", params) };
//上下架课程
export const getStatuscourse= (params) => { return req("post", "/course/modify_status", params) };



//产品管理
export const getCp= (params) => { return req("post", "/agentProduct/index", params) };
//产品管理 添加
export const getCpadd= (params) => { return req("post", "/agentProduct/add", params) };
//产品管理 修改
export const getCpedit= (params) => { return req("post", "/agentProduct/edit", params) };
//产品管理 删除
export const getCpdel= (params) => { return req("post", "/agentProduct/delete", params) };




// WEBPACK FOOTER //
// ./src/api/userMG.js